<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'
        width= '140'>
      </el-table-column>
      <el-table-column
        prop= 'serialNo'
        label= '序列号'
        width= '200'>
      </el-table-column>
      <el-table-column
        prop= 'authCode'
        label= '验证码'
        width= '100'>
      </el-table-column>
      <el-table-column
        prop= 'deviceProjectId'
        label= '产品ID'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'deviceInstantiationGroupId'
        label= '设备组ID'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'deviceModelVersion'
        label= '模型版本号'
        width= '160'>
      </el-table-column>
      <el-table-column
        prop= 'mac'
        label= 'mac地址'
        width= '160'>
      </el-table-column>
      <el-table-column
        prop= 'lineStatus'
        label= '在线状态'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.lineStatus===1">在线</el-button>
          <el-button type='info' size='small' v-if="scope.row.lineStatus===0">离线</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'soft'
        label= '排序[第一展示]'
        width= '160'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '描述'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '260'>
        <template slot-scope='scope'>
          <el-link :href="apiUrl + '/deviceInstantiation/confJson?serialNo='+scope.row.serialNo">导出配置</el-link>
          <el-button @click='resetProperties(scope.row)' type='text' size='small' style="color: #209323">属性编辑</el-button>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible" :modal="false" top="30px">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品ID" :label-width="formLabelWidth" prop="deviceProjectId">
              <el-select v-model="form.deviceProjectId" placeholder="请选择" @change="choseDeviceProject">
                <el-option v-for="item in deviceProjects" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模型版本号" :label-width="formLabelWidth" prop="deviceModelVersion">
              <el-select v-model="form.deviceModelVersion" placeholder="请选择">
                <el-option v-for="item in deviceModels" :key="item.version" :label="item.name" :value="item.version"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="设备组ID" :label-width="formLabelWidth" prop="deviceInstantiationGroupId">
          <el-select v-model="form.deviceInstantiationGroupId" placeholder="请选择">
            <el-option v-for="item in deviceInstantiationGroups" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="序列号" :label-width="formLabelWidth" prop="serialNo">
          <el-input v-model="form.serialNo" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="验证码" :label-width="formLabelWidth" prop="serialNo">
          <el-input v-model="form.authCode" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="mac地址" :label-width="formLabelWidth" prop="mac">
          <el-input v-model="form.mac" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth" prop="soft">
          <el-input type="number" v-model.number="form.soft" autocomplete="off" placeholder="降序排列"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="SIM卡号" :label-width="formLabelWidth" prop="simNo">
              <el-input v-model="form.simNo" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="SIM类型" :label-width="formLabelWidth" prop="simType">
              <el-radio-group v-model="form.simType" size="medium">
                <el-radio-button label=1>移动</el-radio-button>
                <el-radio-button label=2>联通</el-radio-button>
                <el-radio-button label=3>电信</el-radio-button>
                <el-radio-button label=4>广电</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否显示" :label-width="formLabelWidth" prop="isShow">
              <el-radio-group v-model="form.isShow" size="medium">
                <el-radio-button label=1>显示</el-radio-button>
                <el-radio-button label=0>不显示</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="第三方序列号" :label-width="formLabelWidth" prop="thirdSerialNo">
              <el-input v-model="form.thirdSerialNo" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="gps序列号" :label-width="formLabelWidth" prop="gpsSerialNo">
              <el-input v-model="form.gpsSerialNo" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="经度" :label-width="formLabelWidth" prop="lng">
              <el-input v-model="form.lng" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="维度" :label-width="formLabelWidth" prop="lat">
              <el-input v-model="form.lat" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="描述" :label-width="formLabelWidth" prop="descr">
          <el-input v-model="form.descr" autocomplete="off" type="textarea" :rows="8"></el-input>
        </el-form-item>
        <el-form-item label="经纬度坐标" :label-width="formLabelWidth">
          <div id="container" style="width:100%;height:500px;"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="curRow.name + '  重命名属性'" :visible.sync="dialogDeviceInstantiationUserPropertyVisible" width="98%" top="0" :fullscreen="true" :modal="false">
      <DeviceInstantiationUserProperty :deviceInstantiationId="curRow.id"></DeviceInstantiationUserProperty>
    </el-dialog>    
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
import AMapLoader from '@amap/amap-jsapi-loader'
import DeviceInstantiationUserProperty from '../deviceInstantiationUserProperty/Index.vue'
export default {
  components: {
    DeviceInstantiationUserProperty
  },
  props: {
    deviceInstantiationGroupId: {
      type: Number,
      default: 0,
      required: false
    }
  },
  data () {
    return {
      curRow: {},
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        name: null,
        descr: null,
        deviceProjectId: null,
        deviceInstantiationGroupId: null,
        serialNo: null,
        deviceModelVersion: null,
        mac: null,
        soft: null,
        authCode: null,
        lng: null,
        lat: null,
        gpsSerialNo: null,
        thirdSerialNo: null
      },
      rules: {
        name: [{ required: true, message: '名称 不能为空', trigger: ['change', 'blur'] }, { message: '名称 长度范围:[0,32]', min: 0, max: 32, trigger: ['change', 'blur'] }],
        deviceProjectId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '产品ID 不能为空', trigger: ['change', 'blur'] }],
        deviceInstantiationGroupId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        serialNo: [{ required: true, message: '序列号 不能为空', trigger: ['change', 'blur'] }, { message: '序列号 长度范围:[0,32]', min: 0, max: 32, trigger: ['change', 'blur'] }],
        deviceModelVersion: [{ required: true, message: '模型版本号 不能为空', trigger: ['change', 'blur'] }, { message: '模型版本号 长度范围:[0,32]', min: 0, max: 32, trigger: ['change', 'blur'] }],
        lineStatus: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        soft: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        authCode: [{ required: true, message: '验证码 不能为空', trigger: ['change', 'blur'] }, { message: '验证码 长度范围:[0,32]', min: 0, max: 32, trigger: ['change', 'blur'] }]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      deviceProjects: [],
      deviceInstantiationGroups: [],
      deviceModels: [],
      apiUrl: '',
      dialogDeviceInstantiationUserPropertyVisible: false
    }
  },
  created () {
    this.apiUrl = this.$global.apiUrl
    this.query()
    this.queryDeviceProjects()
    this.querDeviceInstantiationGroups()
  },
  watch: {
    deviceInstantiationGroupId: {
      handler (newV, oldV) {
        this.form.deviceInstantiationGroupId = this.deviceInstantiationGroupId
        this.query()
      },
      immediate: true
    }
  },
  methods: {
    resetProperties (row) {
      this.curRow = row
      this.dialogDeviceInstantiationUserPropertyVisible = true
    },
    initAMap () {
      let that = this
      AMapLoader.load({
        key: 'b72c573a626158a27e4ada7a9c853665',
        version: '1.4.15',
        plugins: ['AMap.Driving', 'AMap.MapType']
      }).then((AMap) => {
        that.map = new AMap.Map('container', {
          zoom: 17,
          zooms: [2, 22],
          layers: [
            new AMap.TileLayer.Satellite(),
            new AMap.TileLayer.RoadNet()
          ]
        })
        that.map.on('click', (e) => {
          that.map.clearMap()
          that.form.lng = e.lnglat.getLng()
          that.form.lat = e.lnglat.getLat()
          let position = new AMap.LngLat(that.form.lng, that.form.lat)
          let marker = new AMap.Marker({
            position: position,
            offset: new AMap.Pixel(-13, -30)
          })
          that.map.add(marker)
        })
        if (that.form.lng && that.form.lat) {
          let position = new AMap.LngLat(that.form.lng, that.form.lat)
          that.map.setCenter([that.form.lng, that.form.lat])
          let marker = new AMap.Marker({
            position: position,
            offset: new AMap.Pixel(-13, -30)
          })
          that.map.add(marker)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    choseDeviceProject (val) {
      let that = this
      that.deviceModels = []
      requestService.get(`/deviceModel/listPage?current=1&pageSize=1024000&deviceProjectId=${val}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceModels = res.data.body.records
      })
    },
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/deviceInstantiation/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    queryDeviceProjects () {
      let that = this
      requestService.get(`/deviceProject/listPage?current=1&pageSize=1024000`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceProjects = res.data.body.records
      })
    },
    querDeviceInstantiationGroups () {
      let that = this
      requestService.get(`/deviceInstantiationGroup/listPage?current=1&pageSize=1024000`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceInstantiationGroups = res.data.body.records
      })
    },
    query () {
      let that = this
      requestService.get(`/deviceInstantiation/listPage?current=${that.current}&pageSize=${that.pageSize}&deviceInstantiationGroupId=${that.deviceInstantiationGroupId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
      this.initAMap()
    },
    digAdd () {
      this.form = {deviceInstantiationGroupId: (this.deviceInstantiationGroupId === 0 ? null : this.deviceInstantiationGroupId)}
      this.dialogFormVisible = true
      this.initAMap()
    },
    submitForm (formName) {
      let that = this
      console.log(that.form)
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/deviceInstantiation/add'
          if (that.form.id) {
            url = '/deviceInstantiation/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/deviceInstantiation/Index.vue